"use strict";
//if need unix timestamp divide by 1000
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasDateTimestamp = exports.hasTimestamp = exports.transformTimestamp = exports.getReasonableTimestampSecondsFilter = exports.getReasonableTimestampMsFilter = exports.getReasonableValueNumber = exports.isUTCTimestampInLeapYear = exports.getMonday = exports.onTheHour = exports.hour = exports.now = exports.midnight = void 0;
const core_services_1 = require("@iotv/core-services");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
/*
Unlikely this is a good idea back end without tz handling
*/
//timestamp for midnight
const midnight = () => {
    const dayStart = new Date();
    return dayStart.setHours(0, 0, 0, 0);
};
exports.midnight = midnight;
//timestamp for now
const now = () => {
    return Date.now();
};
exports.now = now;
//24, current hour
const hour = () => {
    return new Date().getHours();
};
exports.hour = hour;
const onTheHour = (hour) => {
    const time = new Date();
    return time.setHours(hour, 0, 0, 0);
};
exports.onTheHour = onTheHour;
const getMonday = (d) => {
    const date = new Date(d);
    var day = date.getDay(), diff = date.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
    return new Date(date.setDate(diff)).valueOf();
};
exports.getMonday = getMonday;
/** Should manually adjust for non-UTC times */
// NZ = +12 hours
const isUTCTimestampInLeapYear = (timestamp) => {
    const year = new Date(timestamp).getFullYear();
    return year % 4 == 0 && year % 100 != 0 && year % 400 != 0;
};
exports.isUTCTimestampInLeapYear = isUTCTimestampInLeapYear;
const getReasonableValueNumber = (lo, hi) => (val) => {
    return (0, iotv_v3_types_1.isNonNaNNumber)(val) && (0, core_services_1.between)(val, lo, hi);
};
exports.getReasonableValueNumber = getReasonableValueNumber;
/** returns true if in provided in ms is within reasonable range */
const getReasonableTimestampMsFilter = (yearsBeforeNow, yearsAfterNow) => (x) => {
    let valid = false;
    if ((0, iotv_v3_types_1.isNonNaNNumber)(x)) {
        const loDate = new Date();
        loDate.setUTCFullYear(loDate.getUTCFullYear() - yearsBeforeNow);
        const hiDate = new Date();
        hiDate.setUTCFullYear(hiDate.getUTCFullYear() + yearsAfterNow);
        valid = (0, core_services_1.between)(x, loDate.valueOf(), hiDate.valueOf());
    }
    return valid;
};
exports.getReasonableTimestampMsFilter = getReasonableTimestampMsFilter;
/** returns true if in provided in SECONDS is within reasonable range */
const getReasonableTimestampSecondsFilter = (yearsBeforeNow, yearsAfterNow) => (x) => {
    let valid = false;
    if ((0, iotv_v3_types_1.isNonNaNNumber)(x)) {
        const loDate = new Date();
        loDate.setUTCFullYear(loDate.getUTCFullYear() - yearsBeforeNow);
        const hiDate = new Date();
        hiDate.setUTCFullYear(hiDate.getUTCFullYear() + yearsAfterNow);
        valid = (0, core_services_1.between)(x * iotv_v3_types_1.Milliseconds.SECOND, loDate.valueOf(), hiDate.valueOf());
    }
    return valid;
};
exports.getReasonableTimestampSecondsFilter = getReasonableTimestampSecondsFilter;
/** converts object.timestamp to ms epoch if present and not already number eg; (Date or string), no check on reasonability
 * if conversion fails, returns original and logs to console
*/
const transformTimestamp = (item) => {
    try {
        if (item.timestamp) {
            if (typeof item.timestamp === 'string')
                item.timestamp = new Date(item.timestamp).valueOf();
            if (item.timestamp instanceof Date)
                item.timestamp = item.timestamp.valueOf();
        }
    }
    catch (e) {
        console.log('transformTimestamp err', e.message);
    }
    return item;
};
exports.transformTimestamp = transformTimestamp;
/** normal timestamp Ms number */
const hasTimestamp = (x) => (0, iotv_v3_types_1.isNonNaNNumber)(x?.timestamp);
exports.hasTimestamp = hasTimestamp;
// Parquet Schema objects will have data timestamps
const hasDateTimestamp = (x) => x?.timestamp instanceof Date;
exports.hasDateTimestamp = hasDateTimestamp;
